import { render, staticRenderFns } from "./HeaderUserPicture.vue?vue&type=template&id=11f94bbd&"
import script from "./HeaderUserPicture.vue?vue&type=script&lang=js&"
export * from "./HeaderUserPicture.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUserPicture.vue?vue&type=style&index=0&id=11f94bbd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports